import { useLPSuspenseQuery } from '../lib/hooks/useLPQuery';
import type { TeamCompletionUser } from '../lib/types/TeamCompletionUser';

export type TeamCompleationTrainingQueryParams = {
  sort?: {
    property: 'name' | 'cyberIqScore';
    sortDirection: 'ascending' | 'descending';
  };
  page?: {
    skip: number;
    take: number;
  };
  completers?: boolean;
  nameFilter?: string;
  campaignId: string;
};

export type TeamTrainingCompleationQueryResponse = {
  total: number;
  skip: number | null;
  take: number | null;
  values: TeamCompletionUser[];
};

export const useManagerTeamCompleationQuery = (params?: TeamCompleationTrainingQueryParams) => {
  return useLPSuspenseQuery<TeamTrainingCompleationQueryResponse>(
    ['ManagerTeamCompleationQuery', params],
    `/manager/teamTrainingCompletions`,
    {},
    undefined,
    {
      method: 'POST',
      json: params,
    },
  );
};
